import { useEffect, useState } from 'react';
import Modal from '../../ui/Modal/Modal';
import Input from '../../ui/Input/Input';
import Button from '../../ui/Button/Button';
import styles from './TransitionPickerModal.module.css';

const PRESETS = [
  'CUT TO:',
  'FADE IN:',
  'FADE OUT:',
  'FADE TO BLACK:',
  'DISSOLVE TO:',
  'MATCH CUT',
  'INTERCUT:',
];

// Picks a screenplay transition. Presets cover the common cases; "Custom"
// lets the writer type any value. Always uppercase on submit.
export default function TransitionPickerModal({ isOpen, onClose, onSubmit }) {
  const [choice, setChoice] = useState(PRESETS[0]);
  const [custom, setCustom] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setChoice(PRESETS[0]);
    setCustom('');
    setError(null);
  }, [isOpen]);

  const submit = () => {
    const v = (choice === '__custom__' ? custom : choice).trim().toUpperCase();
    if (!v) {
      setError('Transition is required');
      return;
    }
    onSubmit(v);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Insert transition"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button onClick={submit}>Insert</Button>
        </>
      }
    >
      <ul className={styles.list}>
        {PRESETS.map((p) => (
          <li
            key={p}
            className={`${styles.row} ${choice === p ? styles.rowActive : ''}`}
            onClick={() => setChoice(p)}
          >
            <span>{p}</span>
          </li>
        ))}
        <li
          className={`${styles.row} ${choice === '__custom__' ? styles.rowActive : ''}`}
          onClick={() => setChoice('__custom__')}
        >
          <span>Custom…</span>
        </li>
      </ul>

      {choice === '__custom__' && (
        <>
          <div className={styles.spacer} />
          <Input
            label="Custom transition"
            placeholder="e.g. SMASH CUT TO:"
            value={custom}
            onChange={(e) => { setCustom(e.target.value); setError(null); }}
            autoFocus
            error={error}
          />
        </>
      )}
    </Modal>
  );
}
